import React from 'react';
import cn from 'classnames';
import Help from '../Help';

import Item from '@components/CheckMarkItem';
import Image from '@components/Image';
import Action from '@components/Button/Action';
import Header from '@components/Modals/Header';

import styles from './Intro.module.scss';
import { AppleDeviceIntegrationProvider } from '@repo/utils/models/Integration';
import { inlineLabelForDeviceIntegrationType } from '@components/Integrations/utils';

// const intro = '/img/messages/intro.png';
// const introLight = '/img/messages/intro-light.png';

const imagesForProvider: Record<
  AppleDeviceIntegrationProvider,
  { intro: string; introLight: string }
> = {
  'apple-messages': {
    intro: '/img/messages/intro-messages.png',
    introLight: '/img/messages/intro-messages-light.png',
  },
  'apple-phone-log': {
    intro: '/img/messages/intro-phone.png',
    introLight: '/img/messages/intro-phone-light.png',
  },
};

const actionForProvider: Record<AppleDeviceIntegrationProvider, string> = {
  'apple-messages': 'message',
  'apple-phone-log': 'call',
};

const privacyInfoForProvider: Record<AppleDeviceIntegrationProvider, string> = {
  'apple-messages': 'Clay never reads or imports message data.',
  'apple-phone-log': 'Clay only imports the phone numbers you call.',
};

const clayProhibitedActionsForProvider: Record<AppleDeviceIntegrationProvider, string> = {
  'apple-messages': 'text',
  'apple-phone-log': 'call',
};

export default function Intro({
  next,
  onClose,
  provider,
  forceDarkMode,
}: {
  next: () => void;
  onClose: () => void;
  provider: AppleDeviceIntegrationProvider;
  forceDarkMode?: boolean;
}) {
  const { intro, introLight } = imagesForProvider[provider];

  return (
    <>
      <Header.Plain onClose={onClose} />
      <div className="modal-content">
        <Image
          className={cn(styles.image, styles[provider])}
          dark={intro}
          light={forceDarkMode ? intro : introLight}
          width="180px"
        />
        <p className={styles.firstParagraph}>
          Connect your {inlineLabelForDeviceIntegrationType[provider]} to Clay in a few simple
          steps.
        </p>
        <Item title="Secure">
          People you {actionForProvider[provider]} will be imported locally. Your information is
          encrypted end-to-end.
        </Item>
        <Item title="Private">{privacyInfoForProvider[provider]}</Item>
        <Item title="Limited Access">
          Clay will never {clayProhibitedActionsForProvider[provider]} anyone or take any other
          actions on your behalf.
        </Item>
        <Action type="button" block onClick={next} forceDarkMode={forceDarkMode}>
          Get started
        </Action>
        <Help forceDarkMode={forceDarkMode} />
      </div>
    </>
  );
}
